<ng-container [ngSwitch]="parameterName">
  <ng-container *ngSwitchCase="PRODUCTS.RAAMSTICKERS">
    <app-window-sticker-size-detail></app-window-sticker-size-detail>
  </ng-container>
  <ng-container *ngSwitchCase="PRODUCTS.PROJECTBORDEN">
    <app-sign-size-detail></app-sign-size-detail>
  </ng-container>
  <ng-container *ngSwitchCase="PRODUCTS.PRINT_PRODUCTION">
    <app-print-production-product></app-print-production-product>
  </ng-container>
</ng-container>
